<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form" @select-data="handleSelectionChange">
        <template
          slot="tableSearch"
          v-if="$store.state.roleId == '1070960390067716097'"
        >
          <el-form-item label="商务编号">
            <el-input
              v-model="form.bizPersonnelId"
              placeholder="商务编号"
            ></el-input>
          </el-form-item>

          <el-form-item label="日期">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>

        </template>



        <template slot="tableColumn">
          <el-table-column
            prop="bizPersonnelId"
            width="90px"
            label="商务id"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="statisticsDate"
            width="90px"
            label="结算日期"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="bizRate"
            width="90px"
            label="点位"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="paymentAmount"
            :formatter="$formatter.FenToYuan"
            width="120px"
            label="代收金额"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="paymentMerFee"
            :formatter="$formatter.FenToYuan"
            width="120px"
            label="商户费用"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="paymentAgentFee"
            :formatter="$formatter.FenToYuan"
            width="120px"
            label="代理费用"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="paymentChannelFee"
            :formatter="$formatter.FenToYuan"
            width="120px"
            label="渠道费用"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="paymentBizAmount"
            :formatter="$formatter.FenToYuan"
            width="120px"
            label="商务提成"
            align="center"
          >
          </el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            prop="transferAmount"
            width="80px"
            :formatter="$formatter.FenToYuan"
            label="代付金额"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="transferMerFee"
            :formatter="$formatter.FenToYuan"
            width="80px"
            label="商户费用"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="transferAgentFee"
            :formatter="$formatter.FenToYuan"
            width="80px"
            label="代理费用"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="transferChannelFee"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="渠道费用"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="transferBizAmount"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="商务提成"
            align="center"
          >
          </el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            prop="todayBizAmount"
            width="80px"
            :formatter="$formatter.FenToYuan"
            label="当日提成"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="monthBizAmount"
            width="80px"
            label="当月提成"
            align="center"
          >
          </el-table-column>


        </template>
      </page>

    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
export default {
  name: 'Systems',
  components: {
    page: Page,
  },
  data() {
    return {
      isShowAgentSelDialog: false,
      formData: null,
      multipleSelection: [],
      strMultipleSelection: [],
      url: '/bizSettlement/selectList',
      action: '',
      timeDate: [],
      form: {
        bizPersonnelId: '',
        startDate: '',
        endDate: '',
      },
    }
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        this.form.startDate = ''
        this.form.endDate = ''
      }
    },
    reset() {
      this.timeDate = []
      this.form.startDate = ''
      this.form.endDate = ''
      this.form.bizPersonnelId = ''

    },



 
  },
}
</script>

<style scoped>
</style>